import React from 'react';
import { Box, Typography, IconButton, Grid, Container, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';

const linkSx = { cursor: 'pointer', '&:hover': { color: 'white' } };

export default function Footer() {
    const navigate = useNavigate();

    return (
        <Box component="footer" sx={{ bgcolor: '#000000', color: 'white', pt: 8, pb: 4, borderTop: '1px solid #222' }}>
            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="space-between">
                    <Grid item xs={12} md={4}>
                        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, fontFamily: 'monospace' }}>
                            Evolv<span style={{ color: '#2cbb5d' }}>e<sup>x</sup></span>
                        </Typography>
                        <Typography variant="body2" color="#a1a1aa" sx={{ maxWidth: '300px' }}>
                            Biology, mobility, art, and arcade agents — in one place.
                        </Typography>
                    </Grid>

                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: 'white' }}>
                            Evolving Systems
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/biological/ai-turing-patterns')}>Biological</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/arcade')}>Arcade</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/robotic/markov-chains')}>Graph Editor</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/robotic/mobility-systems')}>Mobility Systems</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/digital_twins')}>Digital Twins</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/art/audio-visualizer')}>Art</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: 'white' }}>
                            Company
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/docs')}>Docs</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/about')}>About</Typography>
                            <Typography variant="body2" color="#a1a1aa" sx={linkSx} onClick={() => navigate('/contact')}>Contact</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: 'white' }}>
                            Connect
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton size="small" sx={{ color: '#a1a1aa', '&:hover': { color: 'white' } }}>
                                <XIcon fontSize="small" />
                            </IconButton>
                            <IconButton size="small" sx={{ color: '#a1a1aa', '&:hover': { color: 'white' } }}>
                                <FacebookIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ borderColor: '#222', my: 4 }} />

                <Typography variant="body2" color="#555" align="center">
                    Copyright 2026 EvolveX. All Rights Reserved.
                </Typography>
            </Container>
        </Box>
    );
}
